import { useWindowSize } from "@uidotdev/usehooks";
import "./HomepageAnimatedTextImg.css";
import { useEffect, useRef, useState } from "react";

// data = [
//     {
//         id: 1,
//         title: "",
//         description: "",
//         img: File,
//         imgAlt: ""
//     }
// ]Ò

function HomepageAnimatedTextImg({ data }) {
  const imgContainersRef = useRef([]);
  const containerRef = useRef(null);
  const preventScrollRef = useRef(false);
  const preventTransitionRef = useRef(false);
  const scrollIndexRef = useRef(0);
  const { height: windowHeight, width: windowWidth } = useWindowSize();
  const autoScrollOffset = 100;

  const [scrollIndex, setScrollIndex] = useState(0);

  useEffect(() => {
    if (windowWidth > 1200) window.addEventListener("wheel", handleScroll, { passive: false });
    return () => window.removeEventListener("wheel", handleScroll);
  }, [windowHeight, windowWidth]);

  function handleScroll(e) {
    e.preventDefault();

    const container = containerRef.current;
    const containerTop = Math.abs(Math.round(container.getBoundingClientRect().top));

    if (containerTop > autoScrollOffset) handleDefaultScroll(e);
    else if (containerTop > 10) handleTransitionScroll(e);
    else handleCustomScroll(e);
  }

  function handleTransitionScroll(e) {
    if (preventTransitionRef.current) return;

    setTimeout(() => {
      preventTransitionRef.current = false;
    }, 1000);

    preventTransitionRef.current = true;

    const containerTop = Math.round(containerRef.current.getBoundingClientRect().top);

    if (e.deltaY > 0) {
      if (containerTop > 10) {
        preventCustomScroll();
        scrollIndexRef.current = 0;
        setScrollIndex(0);
        return containerRef.current.scrollIntoView();
      }
    } else if (containerTop < 10 && e.deltaY < 0) {
      preventCustomScroll();
      scrollIndexRef.current = data.length - 1;
      setScrollIndex(data.length - 1);
      return containerRef.current.scrollIntoView();
    }
  }

  function preventCustomScroll() {
    if (preventScrollRef.current) return;

    setTimeout(() => {
      preventScrollRef.current = false;
    }, 1000);

    preventScrollRef.current = true;
  }

  function handleCustomScroll(e) {
    if (preventScrollRef.current) return;

    preventCustomScroll();

    if (e.deltaY > 0) handleCustomScrollDown(e);
    else handleCustomScrollUp(e);
  }

  function handleCustomScrollDown(e) {
    const index = scrollIndexRef.current + 1;

    if (index < data.length) {
      scrollIndexRef.current = index;
      setScrollIndex(index);
    } else {
      window.scrollTo({ top: window.scrollY + autoScrollOffset * 3 });
    }
  }

  function handleCustomScrollUp(e) {
    const index = scrollIndexRef.current - 1;

    if (index > -1) {
      scrollIndexRef.current = index;
      setScrollIndex(index);
    } else {
      window.scrollTo({ top: window.scrollY - autoScrollOffset * 3 });
    }
  }

  function handleDefaultScroll(e) {
    const containerTop = Math.round(containerRef.current.getBoundingClientRect().top);
    const delta = Math.round(e.deltaY);
    const windowScroll = Math.round(window.scrollY);
    const pageHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight,
    );

    let newPosition = windowScroll + delta;

    if (containerTop <= 0)
      newPosition = Math.min(pageHeight, Math.max(windowScroll + containerTop + autoScrollOffset, newPosition));
    else newPosition = Math.max(0, Math.min(windowScroll + containerTop - autoScrollOffset, newPosition));

    window.scrollTo({ top: newPosition, behavior: "instant" });
  }

  return (
    <div className={`animated-text-img-container ${windowWidth > 1200 ? "" : "unanimated"}`} ref={containerRef}>
      {windowWidth > 1200 ? (
        <>
          <div className='animated-imgs-container' style={{ "--active-img": scrollIndex }}>
            {data.map((row, index) => (
              <div key={row.id} className='animated-img' ref={el => (imgContainersRef.current[index] = el)}>
                <img src={row.img} alt={row.imgAlt} />
              </div>
            ))}
          </div>
          <div className='animated-texts-container'>
            {data.map((row, index) => (
              <div key={row.id} className={`animated-text ${index === scrollIndex ? "active" : ""}`}>
                <p className='animated-text-title'>{row.title}</p>
                <p className='animated-text-description'>{row.description}</p>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {data.map(row => (
            <div key={row.id} className='unanimated-img-text'>
              <img src={row.img} />
              <div className='unanimated-text'>
                <p className='animated-text-title'>{row.title}</p>
                <p className='animated-text-description'>{row.description}</p>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default HomepageAnimatedTextImg;
